module.exports = __webpack_public_path__ + "media/customizations/mayfairtxlife/logo-0a69920d14666aa92a635717d6bb3d3a.png";